module.exports = __webpack_public_path__ + "img/xnxlc-5-sm.b58a971f.jpg";